import React from 'react'
import { func, shape, string, number } from 'prop-types'
import { rem } from 'polished'
import styled from 'styled-components'
import media, { Grid } from '../../utils/style'
import { Flex, Box } from 'rebass'
import { Link } from 'rebass'
import NumberFormat from 'react-number-format'

/*************************
 STYLES: Filter Bar
 **************************/

const FilterBar = styled(Flex)`
  flex-direction: column;
  justify-content: space-between;
  ${media.SmallishScreenUp`
    flex-direction: row;
  `}
`

const BarBox = styled(Box)`
  color: ${(props) => props.theme.colors.blue};
  font-weight: ${(props) => props.theme.weights[1]};
  font-size: ${(props) => rem(props.theme.fontSizes[2])};
  text-align: center;
`

const ResultsBar = styled(BarBox)``

export const ResultsPagingStats = styled(ResultsBar)`
  font-size: ${(props) => rem(props.theme.fontSizes[2])};
  ${media.SmallishScreenUp`
    font-size: medium;
    cursor: auto;
    text-align: left;
  `};
`
ResultsPagingStats.displayName = 'ResultsPagingStats'

const ResultsSorting = styled(ResultsBar)`
  ${media.LargeScreenUp`
    text-align: right;
  `};
`
ResultsSorting.displayName = 'ResultsSorting'

const Sort = styled(Grid)`
  cursor: pointer;
  color: ${(props) => props.theme.colors.blue};
  font-size: ${(props) => rem(props.theme.fontSizes[2])};

  a,
  path {
    color: ${(props) => props.theme.colors.blue};
    fill: ${(props) => props.theme.colors.blue} !important;
  }

  span {
    color: ${(props) => props.theme.colors.grey_op80};
  }

  &:hover {
    a,
    path {
      color: ${(props) => props.theme.colors.blue_op65};
      fill: ${(props) => props.theme.colors.blue_op65} !important;
    }
  }
`

Sort.displayName = 'Sort'

const SortLink = styled(Link)`
  color: white;
  text-decoration: underline;
`

class VehicleListingFilterBar extends React.PureComponent {
  render() {
    return (
      <FilterBar mx={['5%', '10%', '5%', '10%']} py={[11]} flexWrap="wrap">
        <ResultsPagingStats>
          Used {this.props.page.type}
          {this.props.page.total > 0 && (
            <span>
              <Grid px={2}>|</Grid>
              Showing&nbsp;
              <NumberFormat
                value={this.props.page.total}
                displayType={'text'}
                thousandSeparator
              />
              &nbsp;{this.props.page.type}
            </span>
          )}
        </ResultsPagingStats>
        <ResultsSorting>
          <Sort onClick={this.props.onSort}>
            <span>Sort by {this.props.sortType.property}:</span> &nbsp;
            <SortLink aria-sort={this.props.sortType.direction}>
              {this.props.sortType.label} {this.props.sortType.icon}
            </SortLink>
          </Sort>
        </ResultsSorting>
      </FilterBar>
    )
  }
}

VehicleListingFilterBar.propTypes = {
  sortType: shape({
    ASCENDING: shape({
      property: string,
      direction: string,
      label: string,
      icon: func
    }),
    DESCENDING: shape({
      property: string,
      direction: string,
      label: string,
      icon: func
    })
  }),
  onSort: func,
  page: shape({
    start: number,
    end: number,
    total: number,
    type: string
  })
}
export default VehicleListingFilterBar
